// extracted by mini-css-extract-plugin
export default {"multipleActions":"MultipleActionsProperties_multipleActions__4OPtG","button":"MultipleActionsProperties_button__GpXYj"};